<div class="misc-item">
    <input v-if="type === 'radio'" type="radio" class="misc-item-input" :id="id" :name="name" :value="radioValue" :checked="selected" @change="update">
    <input v-else type="checkbox" class="misc-item-input" :id="id" :v-model="checked" :checked="checked">
    <label class="misc-item-content" :for="id">
        <span class="misc-item-icon">
            <slot name="icon"/>
        </span>
        <span class="misc-item-label"><slot/></span>
    </label>
</div>